"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.speakerMutationUpdates = void 0;
exports.speakerMutationUpdates = {
  eventSpeakerDelete: function eventSpeakerDelete(_result, args, cache, _info) {
    cache.invalidate({
      __typename: 'EventSpeaker',
      id: args.input.eventSpeakerId
    });
  },
  eventSpeakerCreate: function eventSpeakerCreate(result, _args, cache, _info) {
    var _a;

    if (((_a = result.eventSpeakerCreate) === null || _a === void 0 ? void 0 : _a.userErrors.length) === 0) {
      invalidateEventKey(cache, 'speakers');
    }
  },
  eventSpeakerCreateFromRegistrant: function eventSpeakerCreateFromRegistrant(result, _args, cache, _info) {
    var _a;

    if (((_a = result.eventSpeakerCreateFromRegistrant) === null || _a === void 0 ? void 0 : _a.userErrors.length) === 0) {
      invalidateEventKey(cache, 'speakers');
    }
  }
};

var invalidateEventKey = function invalidateEventKey(cache, key) {
  var queryKey = 'Query';
  var userKey = cache.inspectFields(queryKey).filter(function (field) {
    return field.fieldName == 'eventBySlug';
  }).map(function (field) {
    return cache.resolve(queryKey, field.fieldKey);
  })[0];
  cache.inspectFields(userKey).filter(function (field) {
    return field.fieldName === key;
  }).forEach(function (field) {
    return cache.invalidate(userKey, field.fieldKey);
  });
};